import React from "react";
import { LDProvider } from "launchdarkly-react-client-sdk";
import { useSelector } from "react-redux";
import { IReduxAppState } from "../reducers";

interface IFlagsProvider {
  children: React.ReactNode;
}
const ldClientId =
  process.env.REACT_APP_LD_CLIENT_ID ?? "62fcebd01f96ea11a39b2392";

export default function FlagsProvider({ children }: IFlagsProvider) {
  const selectedVenueId = useSelector(
    (state: IReduxAppState) => state.selectedVenueId
  );
  const venue = useSelector(
    (state: IReduxAppState) => state.venue[selectedVenueId]?.venueData
  );
  return (
    <LDProvider
      clientSideID={ldClientId}
      deferInitialization
      reactOptions={{
        useCamelCaseFlagKeys: true,
      }}
      //@ts-ignore
      user={{ key: venue && venue.id, kind: "user" }}
    >
      {children}
    </LDProvider>
  );
}
